import { useMemo } from 'react';

import { Action } from '@interstate/components/Action';
import { Grid } from '@interstate/components/Grid';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import VehicleSearchFilters from './VehicleSearchFilters';
import { AnimatedFiltersWrapper, FiltersSidePanelHeader, FiltersSidePanelTitle } from './VehicleSearchFilters.style';
import { useVehicleSearchFiltersContext } from './VehicleSearchFiltersContext';
import { getSelectedFilterTags } from '../../utils';

export interface VehicleSearchFiltersInlineProps {
    isSearchVehicleTabActive?: boolean;
}

const VehicleSearchFiltersInline = ({ isSearchVehicleTabActive = true }: VehicleSearchFiltersInlineProps) => {
    const theme = useInterstateTheme();
    const { selectedFilters, clearAllFilters } = useVehicleSearchFiltersContext();

    const showClearAll = useMemo(() => getSelectedFilterTags(selectedFilters).length > 0, [selectedFilters]);

    return (
        <AnimatedFiltersWrapper isVisible={isSearchVehicleTabActive} data-testid="vehicle-search-filters-inline">
            <FiltersSidePanelHeader>
                <Grid xs={6}>
                    <FiltersSidePanelTitle>Filters</FiltersSidePanelTitle>
                </Grid>
                {showClearAll && (
                    <Grid xs={6} textAlign="right" alignContent="center">
                        <Action
                            size="sm"
                            sx={{ margin: `0 ${theme.tokens.ComponentBtnSizeSmallPadding}` }}
                            onClick={clearAllFilters}
                            data-testid="left-filtering-clear-all-button"
                        >
                            Clear All
                        </Action>
                    </Grid>
                )}
            </FiltersSidePanelHeader>
            <VehicleSearchFilters />
        </AnimatedFiltersWrapper>
    );
};

export default VehicleSearchFiltersInline;
